import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ExcelJS from "exceljs";
import { getdetailsById } from "../../../Services/pqr-details-service";
import { getbyprojectno } from "../../../Services/pqr-header-service";
import { fetchImagePreview } from "../../utility/common/TransactionComponents/CommonImages";
import BarLoader from "react-spinners/BarLoader";

const Excel_DownloadPQR_Tubesheet = (props) => {
  const [loading, setLoading] = useState(true);
  const [excelData, setExcelData] = useState({ header: [], details: [], imageUrls: {} });

  const fetchExcelData = async (IddetailPK, IddetailSK) => {
    try {
      // Fetch header data
      let reqParam = {
        groovetype: props.rowdata.wld_WPSType,
        pkid: IddetailPK,
        skid: IddetailSK,
      };
      const pqrhead = await getbyprojectno(reqParam);

      // Fetch detail data
      let reqDetailParam = {
        id1: props.rowdata.wld_WPSType,
        id2: IddetailSK,
      };
      const result = await getdetailsById(reqDetailParam);

      // Debug logs for Excel
      console.log('=== EXCEL DATA STRUCTURE ===');
      console.log('Excel Header (pqrhead):', pqrhead);
      console.log('Excel Details (result):', result);
      console.log('Excel Header Length:', pqrhead.length);
      console.log('Excel Details Length:', result.length);
      if (result[0]) {
        console.log('Visual Examination in Excel:', result[0]?.Visual_Examination);
        console.log('Liquid Penetrant in Excel:', result[0]?.Liquid_Penetrant_Examination);
        console.log('Macro Examination in Excel:', result[0]?.Macro_Examination);
        console.log('Minimum Leak Path in Excel:', result[0]?.Minimum_Leak_Path);
      }
      console.log('=== END EXCEL DATA ===');

      // Fetch Tubesheet specific images
      const imageUrls = {
        previewUrl1: null, // tube_Hole_ligament
        previewUrl2: null, // tube_Hole
        previewUrl3: null  // tube_Weld_Joint
      };
      
      const headerData = pqrhead[0];
      let folderpqrtube = "PQR_Tubesheet";
      
      await fetchImagePreview(folderpqrtube, headerData.Pdf_images?.[0]?.tube_Hole_ligament?.[0], (url) => imageUrls.previewUrl1 = url);
      await fetchImagePreview(folderpqrtube, headerData.Pdf_images?.[1]?.tube_Hole?.[0], (url) => imageUrls.previewUrl2 = url);
      await fetchImagePreview(folderpqrtube, headerData.Pdf_images?.[2]?.tube_Weld_Joint?.[0], (url) => imageUrls.previewUrl3 = url);

      setExcelData({ header: pqrhead, details: result, imageUrls: imageUrls });
    } catch (error) {
      console.error("Error fetching Excel data:", error);
      alert("Failed to fetch data for Excel export");
    }
  };

  // Helper function to convert image URL to base64 for Excel embedding
  const getImageAsBase64 = async (imageUrl) => {
    if (!imageUrl) return null;
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error converting image to base64:', error);
      return null;
    }
  };

  useEffect(() => {
    fetchExcelData(props?.rowdata?.PK, props?.rowdata?.PQR_RecordNo);
  }, []);

  const generateExcel = async () => {
    if (excelData.header.length === 0) return;

    try {
      const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("PQR Tubesheet Report");
    const headerData = excelData.header[0];
    const detailsData = excelData.details;
    const detailData = excelData.details[0] || {};

    // Set column widths - all columns A to Z with width 10
    worksheet.columns = [
      { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
      { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
      { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 },
      { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }, { width: 10 }
    ];

    // Title - spanning across more columns like GrooveOverlay
    const titleRow = worksheet.addRow(["Procedure Qualification Record (PQR)"]);
    worksheet.mergeCells('A1:L1'); // Span across columns A to L
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: 'center' };

    worksheet.addRow([]); // Empty row

    // Header table with Tubesheet specific fields - updated column layout
    const headerRow1 = worksheet.addRow([
      "PQR record number", 
      "", // Column B (part of A:B merge for label)
      headerData.PQR_RecordNo || "", 
      "", // Column D
      "", // Column E
      "WPS Record Number", 
      "", // Column G (part of F:G merge for label)
      headerData.PQR_pWPSNo || "", 
      "", // Column I
      "", // Column J
      "Revision: " + (headerData.PQR_WPS_ReviNo || ""),
      "" // Column L (part of K:L merge for value)
    ]);

    const headerRow2 = worksheet.addRow([
      "Date", 
      "", // Column B (part of A:B merge for label)
      headerData.PQR_Date ? new Date(headerData.PQR_Date).toLocaleDateString('en-GB') : "", 
      "", // Column D
      "", // Column E
      "Company Name", 
      "", // Column G (part of F:G merge for label)
      headerData.PQR_CompanyName || "", 
      "", // Column I
      "", // Column J
      "", // Column K
      "" // Column L
    ]);

    const headerRow3 = worksheet.addRow([
      "Qualification Code", 
      "", // Column B (part of A:B merge for label)
      headerData.PQR_Qualificationcode || "", 
      "", // Column D
      "", // Column E
      "Address", 
      "", // Column G (part of F:G merge for label)
      headerData.PQR_Address || "", 
      "", // Column I
      "", // Column J
      "", // Column K
      "" // Column L
    ]);

    // Merge cells for the new layout
    // Row 1 merges
    worksheet.mergeCells(`A${headerRow1.number}:B${headerRow1.number}`); // PQR record number label (A:B)
    worksheet.mergeCells(`C${headerRow1.number}:E${headerRow1.number}`); // PQR record number value (C:D:E)
    worksheet.mergeCells(`F${headerRow1.number}:G${headerRow1.number}`); // pWPS Record Number label (F:G)
    worksheet.mergeCells(`H${headerRow1.number}:J${headerRow1.number}`); // pWPS Record Number value (H:I:J)
    worksheet.mergeCells(`K${headerRow1.number}:L${headerRow1.number}`); // Revision value (K:L)
    
    // Row 2 merges
    worksheet.mergeCells(`A${headerRow2.number}:B${headerRow2.number}`); // Date label (A:B)
    worksheet.mergeCells(`C${headerRow2.number}:E${headerRow2.number}`); // Date value (C:D:E)
    worksheet.mergeCells(`F${headerRow2.number}:G${headerRow2.number}`); // Company Name label (F:G)
    worksheet.mergeCells(`H${headerRow2.number}:J${headerRow2.number}`); // Company Name value (H:I:J)
    
    // Row 3 merges
    worksheet.mergeCells(`A${headerRow3.number}:B${headerRow3.number}`); // Qualification Code label (A:B)
    worksheet.mergeCells(`C${headerRow3.number}:E${headerRow3.number}`); // Qualification Code value (C:D:E)
    worksheet.mergeCells(`F${headerRow3.number}:G${headerRow3.number}`); // Address label (F:G)
    worksheet.mergeCells(`H${headerRow3.number}:J${headerRow3.number}`); // Address value (H:I:J)

    // Style header rows
    [headerRow1, headerRow2, headerRow3].forEach(row => {
      row.eachCell((cell, colNumber) => {
        if (colNumber === 1 || colNumber === 6) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFD3D3D3' }
          };
          cell.font = { bold: true };
        }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    worksheet.addRow([]); // Empty row

    // BASE METALS section for Tubesheet
    const baseMetalTitle = worksheet.addRow(["BASE METALS (QW- 403)", "", ""]);
    worksheet.mergeCells(`A${baseMetalTitle.number}:C${baseMetalTitle.number}`); // Merge title across 3 columns
    baseMetalTitle.getCell(1).font = { bold: true };
    baseMetalTitle.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE6E6FA' }
    };

    // BASE METALS header: A=empty(single), B:C=Product Form, D:F=Spec, G=P no(single), H=G no(single), I:J=Thk, K:L=Dia
    const baseMetalHeader = worksheet.addRow([
      "", "Product Form", "", "Spec.( Type or Grade),UNS#", "", "", "P no", "G no", "Thk.mm", "", "Dia.mm", ""
    ]);
    worksheet.mergeCells(`B${baseMetalHeader.number}:C${baseMetalHeader.number}`);
    worksheet.mergeCells(`D${baseMetalHeader.number}:F${baseMetalHeader.number}`);
    worksheet.mergeCells(`I${baseMetalHeader.number}:J${baseMetalHeader.number}`);
    worksheet.mergeCells(`K${baseMetalHeader.number}:L${baseMetalHeader.number}`);

    // Row1: A=empty(single), B:C=ProductForm, D:F=Spec, G=Pno(single), H=Gno(single), I:J=Thk, K:L=Dia
    const baseMetalRow1 = worksheet.addRow([
      "",
      headerData.PQR_BM_BM_ProductForm || "", "",
      headerData.PQR_BM_BM_Spec || "", "", "",
      headerData.PQR_BM_BM_Pno || "",
      headerData.PQR_BM_BM_Gno || "",
      headerData.PQR_BM_BM_Thk || "", "",
      headerData.PQR_BM_BM_Dia || "", ""
    ]);
    worksheet.mergeCells(`B${baseMetalRow1.number}:C${baseMetalRow1.number}`);
    worksheet.mergeCells(`D${baseMetalRow1.number}:F${baseMetalRow1.number}`);
    worksheet.mergeCells(`I${baseMetalRow1.number}:J${baseMetalRow1.number}`);
    worksheet.mergeCells(`K${baseMetalRow1.number}:L${baseMetalRow1.number}`);

    // Row2: A=Welded To(single), B:C=ProductForm, D:F=Spec, G=Pno(single), H=Gno(single), I:J=Thk, K:L=Dia
    const baseMetalRow2 = worksheet.addRow([
      "Welded To",
      headerData.PQR_BM_WTBM_ProductForm || "", "",
      headerData.PQR_BM_WTBM_Spec || "", "", "",
      headerData.PQR_BM_WTBM_Pno || "",
      headerData.PQR_BM_WTBM_Gno || "",
      headerData.PQR_BM_WTBM_Thk || "", "",
      headerData.PQR_BM_WTBM_Dia || "", ""
    ]);
    worksheet.mergeCells(`B${baseMetalRow2.number}:C${baseMetalRow2.number}`);
    worksheet.mergeCells(`D${baseMetalRow2.number}:F${baseMetalRow2.number}`);
    worksheet.mergeCells(`I${baseMetalRow2.number}:J${baseMetalRow2.number}`);
    worksheet.mergeCells(`K${baseMetalRow2.number}:L${baseMetalRow2.number}`);

    [baseMetalHeader, baseMetalRow1, baseMetalRow2].forEach(row => {
      row.eachCell((cell, colNumber) => {
        if (colNumber === 1 && row === baseMetalRow2) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
        }
        if (row === baseMetalHeader && colNumber !== 1) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });

    worksheet.addRow([]); // Empty row

    // JOINT DETAIL section for Tubesheet - structured like PDF
    const jointDetailTitle = worksheet.addRow(["JOINT DETAIL", "", ""]);
    worksheet.mergeCells(`A${jointDetailTitle.number}:C${jointDetailTitle.number}`); // Title spans 3 columns
    jointDetailTitle.getCell(1).font = { bold: true };
    jointDetailTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Create the 12-column structure: ABC (left header), DEF (left values), GHI (right header), JKL (right values)
    const jointDetailHeader = worksheet.addRow([
      "Joint Type\nTube Pitch (mm)\nTube Projection (mm)\nPattern",
      "", // Column B (part of A:B:C merge)
      "", // Column C (part of A:B:C merge)
      (headerData.PQR_JD_JointType || "") + "\n" + (headerData.PQR_JD_TubePitch || "") + "\n" + (headerData.PQR_JD_TubeProj || "") + "\n" + (headerData.PQR_JD_Pattern || ""),
      "", // Column E (part of D:E:F merge)
      "", // Column F (part of D:E:F merge)
      "Hole Id (mm)\nGroove depth (mm)\nWidth of the ligament (mm)\nGroove Angle(°)/Radius(mm)",
      "", // Column H (part of G:H:I merge)
      "", // Column I (part of G:H:I merge)
      (headerData.PQR_JD_HoleId || "") + "\n" + (headerData.PQR_JD_GrooveDepth || "") + "\n" + (headerData.PQR_JD_WidthLigament || "") + "\n" + (headerData.PQR_JD_GrooveAngle || ""),
      "", // Column K (part of J:K:L merge)
      "" // Column L (part of J:K:L merge)
    ]);

    // Merge cells for joint detail section
    worksheet.mergeCells(`A${jointDetailHeader.number}:C${jointDetailHeader.number}`); // Left header (A:B:C)
    worksheet.mergeCells(`D${jointDetailHeader.number}:F${jointDetailHeader.number}`); // Left values (D:E:F)
    worksheet.mergeCells(`G${jointDetailHeader.number}:I${jointDetailHeader.number}`); // Right header (G:H:I)
    worksheet.mergeCells(`J${jointDetailHeader.number}:L${jointDetailHeader.number}`); // Right values (J:K:L)

    // Style the joint detail section
    jointDetailHeader.eachCell((cell, colNumber) => {
      if (colNumber === 1 || colNumber === 7) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
      }
      cell.alignment = { wrapText: true, vertical: 'top' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    
    // Set row height for better display of multi-line content
    jointDetailHeader.height = 88;

    // Add image areas for Tubesheet - each image takes 4 columns
    const imageAreaRow = worksheet.addRow([
      "Tube Hole Ligament Detail", 
      "", // Column B (part of A:B:C:D merge)
      "", // Column C (part of A:B:C:D merge)
      "", // Column D (part of A:B:C:D merge)
      "Tube Hole Detail", 
      "", // Column F (part of E:F:G:H merge)
      "", // Column G (part of E:F:G:H merge)
      "", // Column H (part of E:F:G:H merge)
      "Tube to Tubesheet Weld Joint Detail", 
      "", // Column J (part of I:J:K:L merge)
      "", // Column K (part of I:J:K:L merge)
      "" // Column L (part of I:J:K:L merge)
    ]);

    // Merge cells for image area headers
    worksheet.mergeCells(`A${imageAreaRow.number}:D${imageAreaRow.number}`); // First image header (A:B:C:D)
    worksheet.mergeCells(`E${imageAreaRow.number}:H${imageAreaRow.number}`); // Second image header (E:F:G:H)
    worksheet.mergeCells(`I${imageAreaRow.number}:L${imageAreaRow.number}`); // Third image header (I:J:K:L)

    // Style the image area row
    imageAreaRow.eachCell((cell, colNumber) => {
      if (colNumber === 1 || colNumber === 5 || colNumber === 9) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF0F0F0' } };
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Add empty row for image placeholders
    const imageRow = worksheet.addRow(["", "", "", "", "", "", "", "", "", "", "", ""]);
    imageRow.height = 120;
    
    // Merge cells for image placeholders
    worksheet.mergeCells(`A${imageRow.number}:D${imageRow.number}`); // First image area (A:B:C:D)
    worksheet.mergeCells(`E${imageRow.number}:H${imageRow.number}`); // Second image area (E:F:G:H)
    worksheet.mergeCells(`I${imageRow.number}:L${imageRow.number}`); // Third image area (I:J:K:L)
    
    imageRow.eachCell((cell, colNumber) => {
      if (colNumber === 1 || colNumber === 5 || colNumber === 9) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Add actual images if available - using same dimensions as GrooveOverlay
    try {
      if (excelData.imageUrls.previewUrl1) {
        const image1Base64 = await getImageAsBase64(excelData.imageUrls.previewUrl1);
        if (image1Base64) {
          const imageId1 = workbook.addImage({
            base64: image1Base64,
            extension: 'png',
          });
          worksheet.addImage(imageId1, {
            tl: { col: 0, row: imageRow.number - 1 }, // Column A (index 0)
            ext: { width: 280, height: 105 } // Same dimensions as GrooveOverlay
          });
        }
      }
      
      if (excelData.imageUrls.previewUrl2) {
        const image2Base64 = await getImageAsBase64(excelData.imageUrls.previewUrl2);
        if (image2Base64) {
          const imageId2 = workbook.addImage({
            base64: image2Base64,
            extension: 'png',
          });
          worksheet.addImage(imageId2, {
            tl: { col: 4, row: imageRow.number - 1 }, // Column E (index 4)
            ext: { width: 280, height: 105 } // Same dimensions as GrooveOverlay
          });
        }
      }
      
      if (excelData.imageUrls.previewUrl3) {
        const image3Base64 = await getImageAsBase64(excelData.imageUrls.previewUrl3);
        if (image3Base64) {
          const imageId3 = workbook.addImage({
            base64: image3Base64,
            extension: 'png',
          });
          worksheet.addImage(imageId3, {
            tl: { col: 8, row: imageRow.number - 1 }, // Column I (index 8)
            ext: { width: 280, height: 105 } // Same dimensions as GrooveOverlay
          });
        }
      }
    } catch (imageError) {
      console.error('Error adding images to Excel:', imageError);
      // Fallback to text if image embedding fails
      worksheet.getCell(`A${imageRow.number}`).value = "[Image Area 1]";
      worksheet.getCell(`E${imageRow.number}`).value = "[Image Area 2]";
      worksheet.getCell(`I${imageRow.number}`).value = "[Image Area 3]";
    }

    const notesRow = worksheet.addRow(["Notes", "", headerData.PQR_Image_Notes || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${notesRow.number}:B${notesRow.number}`); // Notes header spans A:B
    worksheet.mergeCells(`C${notesRow.number}:L${notesRow.number}`); // Notes value spans C:L
    notesRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) { // Only column A gets the styling since A:B is merged
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRow([]); // Empty row

    // FILLER METALS section
    const fillerMetalTitle = worksheet.addRow(["FILLER METALS (QW- 404)", "", ""]);
    worksheet.mergeCells(`A${fillerMetalTitle.number}:C${fillerMetalTitle.number}`); // Title spans A:B:C (3 columns)
    fillerMetalTitle.getCell(1).font = { bold: true };
    fillerMetalTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Header: A:B=empty, C:D=SFA, E:F=Classification, G=F no(single), H=A no(single), I:L=Chemical Analysis
    const fillerMetalHeader = worksheet.addRow(["", "", "SFA", "", "Classification", "", "F no", "A no", "Chemical Analysis or Trade name", "", "", ""]);
    worksheet.mergeCells(`A${fillerMetalHeader.number}:B${fillerMetalHeader.number}`);
    worksheet.mergeCells(`C${fillerMetalHeader.number}:D${fillerMetalHeader.number}`);
    worksheet.mergeCells(`E${fillerMetalHeader.number}:F${fillerMetalHeader.number}`);
    worksheet.mergeCells(`I${fillerMetalHeader.number}:L${fillerMetalHeader.number}`);

    const fillerMetalRow = worksheet.addRow([
      "GTAW", "",
      detailData.WPSD_FM_SFA || "", "",
      detailData.WPSD_FM_Classification || "", "",
      detailData.WPSD_FM_FNo || "",
      detailData.WPSD_FM_Ano || "",
      detailData.WPSD_FM_ChemicalAnalysis_TradeName || "", "", "", ""
    ]);
    worksheet.mergeCells(`A${fillerMetalRow.number}:B${fillerMetalRow.number}`);
    worksheet.mergeCells(`C${fillerMetalRow.number}:D${fillerMetalRow.number}`);
    worksheet.mergeCells(`E${fillerMetalRow.number}:F${fillerMetalRow.number}`);
    worksheet.mergeCells(`I${fillerMetalRow.number}:L${fillerMetalRow.number}`);

    [fillerMetalHeader, fillerMetalRow].forEach(row => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        if (row === fillerMetalHeader && colNumber >= 3) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
        }
        if (row === fillerMetalRow && colNumber === 1) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    worksheet.addRow([]); // Empty row

    // WELDING PROCEDURE section
    const weldingProcTitle = worksheet.addRow(["WELDING PROCEDURE", "", "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${weldingProcTitle.number}:C${weldingProcTitle.number}`);
    weldingProcTitle.getCell(1).font = { bold: true };
    weldingProcTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Single-value rows (first block): label=A:C, value=D:L
    const weldingSingleFields = [
      { label: "Welding Process & Type", value: detailData.PQRD_WP_WeldingProcess || "GTAW" },
      { label: "Min. Preheat Temperature", value: detailData.PQRD_WP_MinimumPreheatTemp || "" },
      { label: "Max. Interpass temperature", value: detailData.PQRD_WP_MaximumInterpassTemp || "" },
      { label: "Post Heating / DHT", value: detailData.PQRD_WP_PostHeating || "" },
      { label: "Tungsten Type & Size", value: detailData.PQRD_WP_TungstenType || "" },
      { label: "Welding Position", value: detailData.PQRD_WP_WeldPosition || "" },
      { label: "Progression", value: detailData.PQRD_WP_WeldProgression || "" },
      { label: "No of Passes", value: detailData.PQRD_WP_NoofPasses || "" }
    ];

    weldingSingleFields.forEach(field => {
      const row = worksheet.addRow([field.label, "", "", field.value, "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`D${row.number}:L${row.number}`);
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      row.getCell(1).font = { bold: true };
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    // Multi-value rows: label=A:C, val1=D:F, val2=G:I, val3=J:L
    const weldingMultiFields = [
      {
        label: "Layer Number",
        v1: detailData.PQRD_WP_LayerNo?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_LayerNo?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_LayerNo?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Filler Metal Size (mm)",
        v1: detailData.PQRD_WP_FillerMetalSize?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_FillerMetalSize?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_FillerMetalSize?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Amperes (Amps)",
        v1: detailData.PQRD_WP_Amperes?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_Amperes?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_Amperes?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "DC pulsing Current (Amps)",
        v1: detailData.PQRD_WP_DC_Pulsing_current?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_DC_Pulsing_current?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_DC_Pulsing_current?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "DC pulsing Current - Others (Amps)",
        v1: detailData.PQRD_WP_DC_Pulsing_current_Others?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_DC_Pulsing_current_Others?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_DC_Pulsing_current_Others?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Voltage (Volts)",
        v1: detailData.PQRD_WP_Volatage_Volts?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_Volatage_Volts?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_Volatage_Volts?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Heat Input (KJ/mm)",
        v1: detailData.PQRD_WP_Heat_Input?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_Heat_Input?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_Heat_Input?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Travel Speed (mm/min)",
        v1: detailData.PQRD_WP_Travel_Speed?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_Travel_Speed?.[1]?.Value_B?.[0] || "--",
        v3: detailData.PQRD_WP_Travel_Speed?.[2]?.Value_C?.[0] || "--"
      },
      {
        label: "Polarity or current type",
        v1: detailData.PQRD_WP_PolarityOrCurrent?.[0]?.Value_A?.[0] || "--",
        v2: detailData.PQRD_WP_PolarityOrCurrent?.[1]?.Value_B?.[0] || "--",
        v3: ""
      }
    ];

    weldingMultiFields.forEach(field => {
      const row = worksheet.addRow([field.label, "", "", field.v1, "", "", field.v2, "", "", field.v3, "", ""]);
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`D${row.number}:F${row.number}`);
      worksheet.mergeCells(`G${row.number}:I${row.number}`);
      worksheet.mergeCells(`J${row.number}:L${row.number}`);
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      row.getCell(1).font = { bold: true };
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    // Single-value rows (second block, after multi-value): label=A:C, value=D:L
    const weldingTrailingFields = [
      { label: "Automatic Arc Voltage Control", value: detailData.PQRD_WP_ArcVoltageControl || "" },
      { label: "Shielding Gas Type (%Comp)", value: detailData.PQRD_WP_ShieldingGasType || "" },
      { label: "Flow Rate (l/min)", value: detailData.PQRD_WP_ShieldingFlowRate || "" },
      { label: "Auxiliary Gas Shield System", value: detailData.PQRD_WP_Auxiliarygas || "" },
      { label: "Expansion", value: detailData.PQRD_WP_Expansion || "" },
      { label: "Method of Cleaning", value: detailData.PQRD_WP_MethodofCleaning || "" }
    ];

    weldingTrailingFields.forEach(field => {
      const row = worksheet.addRow([field.label, "", "", field.value, "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`D${row.number}:L${row.number}`);
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      row.getCell(1).font = { bold: true };
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    // 2-value fields: label=A:C, val1=D:H, val2=I:L
    const weldingDualFields = [
      { label: "Single/Multi Electrode",  field: "PQRD_WP_SingleMultiElectrode" },
      { label: "Peening",                  field: "PQRD_WP_Peening" },
      { label: "Use of Thermal Process",   field: "PQRD_WP_ThermalProcess" },
      { label: "String & Weave",           field: "PQRD_WP_StringWeave" },
      { label: "Oscillation",              field: "PQRD_WP_Oscillation" },
      { label: "Orifice Cup Size in mm",   field: "PQRD_WP_OrificeCupSize" },
      { label: "Closed to Out Chamber",    field: "PQRD_WP_ClosedOutChamber" },
    ];

    weldingDualFields.forEach(field => {
      const rawVal = detailData[field.field];
      const val1 = Array.isArray(rawVal) ? (rawVal[0] || "") : (rawVal || "");
      const val2 = Array.isArray(rawVal) ? (rawVal[1] || "") : "";
      const row = worksheet.addRow([field.label, "", "", val1, "", "", "", "", val2, "", "", ""]);
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`D${row.number}:H${row.number}`);
      worksheet.mergeCells(`I${row.number}:L${row.number}`);
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      row.getCell(1).font = { bold: true };
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    });

    worksheet.addRow([]); // Empty row

    // POST WELD HEAT TREATMENT section
    const pwhtTitle = worksheet.addRow(["POST WELD HEAT TREATMENT (QW-407)", "", "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${pwhtTitle.number}:D${pwhtTitle.number}`);
    pwhtTitle.getCell(1).font = { bold: true };
    pwhtTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Row 1: A:B=Temp label, C:D=Temp val, E:F=Time label, G:H=Time val, I:J=Type label (vertically merged), K:L=Type val (vertically merged)
    // Row 2: A:B=Heating Rate label, C:D=Heating Rate val, E:F=Cooling Rate label, G:H=Cooling Rate val
    const pwhtRow1 = worksheet.addRow([
      "Temperature (°C)", "",
      headerData.PQR_PWHeatTre_Temperature || "", "",
      "Time (Minutes)", "",
      headerData.PQR_PWHeatTre_Time || "", "",
      "Type", "",
      headerData.PQR_PWHeatTre_Type || "", ""
    ]);
    const pwhtRow2 = worksheet.addRow([
      "Heating Rate (°C/Hr)", "",
      headerData.PQR_PWHeatTre_Heating_Rate || "", "",
      "Cooling Rate (°C/Hr)", "",
      headerData.PQR_PWHeatTre_Cooling_Rate || "", "",
      "", "", "", ""
    ]);

    [pwhtRow1, pwhtRow2].forEach(row => {
      worksheet.mergeCells(`A${row.number}:B${row.number}`);
      worksheet.mergeCells(`C${row.number}:D${row.number}`);
      worksheet.mergeCells(`E${row.number}:F${row.number}`);
      worksheet.mergeCells(`G${row.number}:H${row.number}`);
    });

    // Vertically merge Type label and value across both rows
    worksheet.mergeCells(`I${pwhtRow1.number}:J${pwhtRow2.number}`);
    worksheet.mergeCells(`K${pwhtRow1.number}:L${pwhtRow2.number}`);

    [pwhtRow1, pwhtRow2].forEach(row => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        if (colNumber === 1 || colNumber === 5) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
        }
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });
    // Style Type label and value cells (top-left of each vertical merge)
    worksheet.getCell(`I${pwhtRow1.number}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
    worksheet.getCell(`I${pwhtRow1.number}`).font = { bold: true };
    worksheet.getCell(`I${pwhtRow1.number}`).alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getCell(`K${pwhtRow1.number}`).alignment = { horizontal: 'center', vertical: 'middle' };

    // Notes: A=label(single), B:L=value
    const pwhtNotesRow = worksheet.addRow(["Notes", headerData.PQR_PWHeatTre_Notes || "", "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`B${pwhtNotesRow.number}:L${pwhtNotesRow.number}`);
    pwhtNotesRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      } else {
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRow([]); // Empty row

    // CERTIFICATION section
    const certTitle = worksheet.addRow(["CERTIFICATION", "", "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${certTitle.number}:B${certTitle.number}`);
    certTitle.getCell(1).font = { bold: true };
    certTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const certConductedBy = headerData?.PQR_Certification_ConductedBy || "";
    const certArray = headerData?.Certification || [];
    const certLabRefArray = headerData?.CertificationLabRef || [];

    // Header row: labels + Tests conducted by value
    const certRow1 = worksheet.addRow([
      "Welder's Name", "",
      "ID", "",
      "Process", "",
      "Tests conducted by", "", "",
      certConductedBy, "", ""
    ]);
    worksheet.mergeCells(`A${certRow1.number}:B${certRow1.number}`);
    worksheet.mergeCells(`C${certRow1.number}:D${certRow1.number}`);
    worksheet.mergeCells(`E${certRow1.number}:F${certRow1.number}`);
    worksheet.mergeCells(`G${certRow1.number}:I${certRow1.number}`);
    worksheet.mergeCells(`J${certRow1.number}:L${certRow1.number}`);
    certRow1.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      if (colNumber === 1 || colNumber === 3 || colNumber === 5 || colNumber === 7) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Data rows with lab ref values alongside — first row has "Laboratory ref. number" label
    const certLabRefNumbers = [];
    certLabRefArray.forEach(item => {
      if (item?.PQR_Certification_Lab_RefNo && item.PQR_Certification_Lab_RefNo.trim() !== "") {
        certLabRefNumbers.push(item.PQR_Certification_Lab_RefNo);
      }
    });

    const maxCertRows = Math.max(certArray.length, certLabRefNumbers.length, 1);
    for (let i = 0; i < maxCertRows; i++) {
      const cert = certArray[i] || {};
      const isFirstRow = i === 0;
      const refNo = isFirstRow ? "Laboratory ref. number" : (certLabRefNumbers[i - 1] || "");
      const dataRow = worksheet.addRow([
        cert.PQR_Certification_Welder_Name || "", "",
        cert.PQR_Certification_ID || "", "",
        cert.PQR_Certification_Process || "", "",
        refNo, "", "", "", "", ""
      ]);
      worksheet.mergeCells(`A${dataRow.number}:B${dataRow.number}`);
      worksheet.mergeCells(`C${dataRow.number}:D${dataRow.number}`);
      worksheet.mergeCells(`E${dataRow.number}:F${dataRow.number}`);
      worksheet.mergeCells(`G${dataRow.number}:L${dataRow.number}`);
      if (isFirstRow) {
        dataRow.getCell(7).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        dataRow.getCell(7).font = { bold: true };
      }
      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    worksheet.addRow([]); // Empty row

    // PAGE 2 CONTENT
    // VISUAL EXAMINATION section
    const visualExamTitle = worksheet.addRow(["VISUAL EXAMINATION", "", ""]);
    worksheet.mergeCells(`A${visualExamTitle.number}:C${visualExamTitle.number}`); // Title spans A:B:C (3 columns)
    visualExamTitle.getCell(1).font = { bold: true };
    visualExamTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const visualExamHeader = worksheet.addRow(["Weld Pass", "", "", "Acceptance Criteria", "", "", "Observation", "", "", "Results", "", ""]);
    
    // Merge header cells (3 columns each)
    worksheet.mergeCells(`A${visualExamHeader.number}:C${visualExamHeader.number}`); // Weld Pass (A:B:C)
    worksheet.mergeCells(`D${visualExamHeader.number}:F${visualExamHeader.number}`); // Acceptance Criteria (D:E:F)
    worksheet.mergeCells(`G${visualExamHeader.number}:I${visualExamHeader.number}`); // Observation (G:H:I)
    worksheet.mergeCells(`J${visualExamHeader.number}:L${visualExamHeader.number}`); // Results (J:K:L)
    
    visualExamHeader.eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      cell.font = { bold: true };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Add Visual Examination data - matching PDF structure exactly
    // PDF shows Visual_Examination is in PDF[0] (header), not PDF[1] (details)
    let visualExamData = [];
    
    // Check header data first (like PDF does)
    const headerVisualExam = excelData.header[0]?.Visual_Examination || [];
    console.log('Header Visual Examination:', headerVisualExam);
    
    if (headerVisualExam.length > 0) {
      headerVisualExam.forEach(item => {
        visualExamData.push(item);
      });
    }
    
    // Also check details data (PDF checks both)
    for (let i = 0; i < excelData.details.length; i++) {
      const detailVisualExam = excelData.details[i]?.Visual_Examination || [];
      console.log(`Details[${i}] Visual Examination:`, detailVisualExam);
      
      detailVisualExam.forEach(item => {
        visualExamData.push(item);
      });
    }
    
    console.log('Combined Visual Examination Data:', visualExamData);
    
    if (visualExamData.length > 0) {
      visualExamData.forEach(item => {
        console.log('Processing visual item:', item);
        const row = worksheet.addRow([
          item.PQR_VEX_WeldPass !== "" ? item.PQR_VEX_WeldPass : "--",
          "", // Column B (part of A:B:C merge)
          "", // Column C (part of A:B:C merge)
          item.PQR_VEX_Acceptance_Criteria !== "" ? item.PQR_VEX_Acceptance_Criteria : "--",
          "", // Column E (part of D:E:F merge)
          "", // Column F (part of D:E:F merge)
          item.PQR_VEX_Observation !== "" ? item.PQR_VEX_Observation : "--",
          "", // Column H (part of G:H:I merge)
          "", // Column I (part of G:H:I merge)
          item.PQR_VEX_Results !== "" ? item.PQR_VEX_Results : "--",
          "", // Column K (part of J:K:L merge)
          "" // Column L (part of J:K:L merge)
        ]);
        
        // Merge data cells (3 columns each)
        worksheet.mergeCells(`A${row.number}:C${row.number}`); // Weld Pass (A:B:C)
        worksheet.mergeCells(`D${row.number}:F${row.number}`); // Acceptance Criteria (D:E:F)
        worksheet.mergeCells(`G${row.number}:I${row.number}`); // Observation (G:H:I)
        worksheet.mergeCells(`J${row.number}:L${row.number}`); // Results (J:K:L)
        
        row.eachCell((cell) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    } else {
      // Add empty row if no data
      const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "--", "", ""]);
      
      // Merge empty data cells (3 columns each)
      worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`); // Weld Pass (A:B:C)
      worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`); // Acceptance Criteria (D:E:F)
      worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`); // Observation (G:H:I)
      worksheet.mergeCells(`J${emptyRow.number}:L${emptyRow.number}`); // Results (J:K:L)
      
      emptyRow.eachCell((cell) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    // Visual Examination Notes - check both header and details
    const visualNotes = excelData.header[0]?.PQR_VEX_Notes || excelData.details[0]?.PQR_VEX_Notes || "";
    const visualNotesRow = worksheet.addRow(["Notes", "", visualNotes, "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${visualNotesRow.number}:B${visualNotesRow.number}`); // Notes header spans A:B (2 columns)
    worksheet.mergeCells(`C${visualNotesRow.number}:L${visualNotesRow.number}`); // Notes value spans C:L (10 columns)
    visualNotesRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) { // Only column A gets the styling since A:B is merged
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Visual Examination Report Number
    const visualReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_VEX_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${visualReportRow.number}:B${visualReportRow.number}`); // Report Number header spans A:B (2 columns)
    worksheet.mergeCells(`C${visualReportRow.number}:L${visualReportRow.number}`); // Report Number value spans C:L (10 columns)
    visualReportRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) { // Only column A gets the styling since A:B is merged
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRow([]); // Empty row

    // LIQUID PENETRANT EXAMINATION section
    const liquidPenetrantTitle = worksheet.addRow(["LIQUID PENETRANT EXAMINATION", "", ""]);
    worksheet.mergeCells(`A${liquidPenetrantTitle.number}:C${liquidPenetrantTitle.number}`); // Title spans A:B:C (3 columns)
    liquidPenetrantTitle.getCell(1).font = { bold: true };
    liquidPenetrantTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const liquidPenetrantHeader = worksheet.addRow(["Weld Pass", "", "", "Acceptance Criteria", "", "", "Observation", "", "", "Results", "", ""]);
    
    // Merge header cells (3 columns each)
    worksheet.mergeCells(`A${liquidPenetrantHeader.number}:C${liquidPenetrantHeader.number}`); // Weld Pass (A:B:C)
    worksheet.mergeCells(`D${liquidPenetrantHeader.number}:F${liquidPenetrantHeader.number}`); // Acceptance Criteria (D:E:F)
    worksheet.mergeCells(`G${liquidPenetrantHeader.number}:I${liquidPenetrantHeader.number}`); // Observation (G:H:I)
    worksheet.mergeCells(`J${liquidPenetrantHeader.number}:L${liquidPenetrantHeader.number}`); // Results (J:K:L)
    
    liquidPenetrantHeader.eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      cell.font = { bold: true };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Add Liquid Penetrant Examination data - matching PDF structure exactly
    // Check both header and details data like Visual Examination
    let liquidPenetrantData = [];
    
    // Check header data first (like PDF does)
    const headerLiquidPenetrant = excelData.header[0]?.Liquid_Penetrant_Examination || [];
    console.log('Header Liquid Penetrant Examination:', headerLiquidPenetrant);
    
    if (headerLiquidPenetrant.length > 0) {
      headerLiquidPenetrant.forEach(item => {
        liquidPenetrantData.push(item);
      });
    }
    
    // Also check details data (PDF checks both)
    for (let i = 0; i < excelData.details.length; i++) {
      const detailLiquidPenetrant = excelData.details[i]?.Liquid_Penetrant_Examination || [];
      console.log(`Details[${i}] Liquid Penetrant Examination:`, detailLiquidPenetrant);
      
      detailLiquidPenetrant.forEach(item => {
        liquidPenetrantData.push(item);
      });
    }
    
    console.log('Combined Liquid Penetrant Examination Data:', liquidPenetrantData);
    
    if (liquidPenetrantData.length > 0) {
      liquidPenetrantData.forEach(item => {
        console.log('Processing liquid penetrant item:', item);
        const row = worksheet.addRow([
          item.PQR_LPEX_WeldPass !== "" ? item.PQR_LPEX_WeldPass : "--",
          "", // Column B (part of A:B:C merge)
          "", // Column C (part of A:B:C merge)
          item.PQR_LPEX_Acceptance_Criteria !== "" ? item.PQR_LPEX_Acceptance_Criteria : "--",
          "", // Column E (part of D:E:F merge)
          "", // Column F (part of D:E:F merge)
          item.PQR_LPEX_Observation !== "" ? item.PQR_LPEX_Observation : "--",
          "", // Column H (part of G:H:I merge)
          "", // Column I (part of G:H:I merge)
          item.PQR_LPEX_Results !== "" ? item.PQR_LPEX_Results : "--",
          "", // Column K (part of J:K:L merge)
          "" // Column L (part of J:K:L merge)
        ]);
        
        // Merge data cells (3 columns each)
        worksheet.mergeCells(`A${row.number}:C${row.number}`); // Weld Pass (A:B:C)
        worksheet.mergeCells(`D${row.number}:F${row.number}`); // Acceptance Criteria (D:E:F)
        worksheet.mergeCells(`G${row.number}:I${row.number}`); // Observation (G:H:I)
        worksheet.mergeCells(`J${row.number}:L${row.number}`); // Results (J:K:L)
        
        row.eachCell((cell) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    } else {
      // Add empty row if no data
      const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "--", "", ""]);
      
      // Merge empty data cells (3 columns each)
      worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`); // Weld Pass (A:B:C)
      worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`); // Acceptance Criteria (D:E:F)
      worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`); // Observation (G:H:I)
      worksheet.mergeCells(`J${emptyRow.number}:L${emptyRow.number}`); // Results (J:K:L)
      
      emptyRow.eachCell((cell) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    // Liquid Penetrant Notes - check both header and details
    const liquidNotes = excelData.header[0]?.PQR_LPEX_Notes || excelData.details[0]?.PQR_LPEX_Notes || "";
    const liquidNotesRow = worksheet.addRow(["Notes", "", liquidNotes, "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${liquidNotesRow.number}:B${liquidNotesRow.number}`); // Notes header spans A:B (2 columns)
    worksheet.mergeCells(`C${liquidNotesRow.number}:L${liquidNotesRow.number}`); // Notes value spans C:L (10 columns)
    liquidNotesRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) { // Only column A gets the styling since A:B is merged
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Liquid Penetrant Report Number
    const liquidReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_LPEX_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${liquidReportRow.number}:B${liquidReportRow.number}`); // Report Number header spans A:B (2 columns)
    worksheet.mergeCells(`C${liquidReportRow.number}:L${liquidReportRow.number}`); // Report Number value spans C:L (10 columns)
    liquidReportRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) { // Only column A gets the styling since A:B is merged
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRow([]); // Empty row

    // MACRO EXAMINATION section
    if (headerData.macroCheck !== "No") {
    const macroExamTitle = worksheet.addRow(["MACRO EXAMINATION", "", ""]);
    worksheet.mergeCells(`A${macroExamTitle.number}:C${macroExamTitle.number}`);
    macroExamTitle.getCell(1).font = { bold: true };
    macroExamTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    let allMacroData = [];
    if (excelData.header[0]?.Macro_Examination) allMacroData.push(...excelData.header[0].Macro_Examination);
    for (let i = 0; i < excelData.details.length; i++) allMacroData.push(...(excelData.details[i]?.Macro_Examination || []));

    // Cols A-E = Table6, F-G = gap, H-L = Table7 (single cells)
    const macroSideBySideHeader = worksheet.addRow(["Tube No", "Loc A", "Loc B", "Loc C", "Loc D", "", "", "Tube No", "Loc A", "Loc B", "Loc C", "Loc D"]);
    macroSideBySideHeader.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      if (colNumber !== 6 && colNumber !== 7) {
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    let table6Data = [], table7Data = [];
    for (let i = 0; i < allMacroData.length; i++) {
      table6Data.push(...(allMacroData[i]?.Table6 || []));
      table7Data.push(...(allMacroData[i]?.Table7 || []));
    }

    const macroMaxRows = Math.max(table6Data.length, table7Data.length, 1);
    for (let rowIndex = 0; rowIndex < macroMaxRows; rowIndex++) {
      const t6 = table6Data[rowIndex];
      const t7 = table7Data[rowIndex];
      const dataRow = worksheet.addRow([
        t6?.PQR_MEX_Tube_No || "--", t6?.PQR_MEX_LocA || "--", t6?.PQR_MEX_LocB || "--", t6?.PQR_MEX_LocC || "--", t6?.PQR_MEX_LocD || "--", "", "",
        t7?.PQR_MEX_Tube_No || "--", t7?.PQR_MEX_LocA || "--", t7?.PQR_MEX_LocB || "--", t7?.PQR_MEX_LocC || "--", t7?.PQR_MEX_LocD || "--"
      ]);
      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    worksheet.addRow([]);

    // Summary: A:C=Magnification, D:F=AccCriteria, G:I=Observation
    const macroSummaryHeader = worksheet.addRow(["Magnification", "", "", "Acceptance Criteria", "", "", "Observation", "", "", "", "", ""]);
    worksheet.mergeCells(`A${macroSummaryHeader.number}:C${macroSummaryHeader.number}`);
    worksheet.mergeCells(`D${macroSummaryHeader.number}:F${macroSummaryHeader.number}`);
    worksheet.mergeCells(`G${macroSummaryHeader.number}:I${macroSummaryHeader.number}`);
    macroSummaryHeader.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 9) return;
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      cell.font = { bold: true };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    let hasTable10Data = false;
    for (let i = 0; i < allMacroData.length; i++) {
      (allMacroData[i]?.Table10 || []).forEach(item => {
        hasTable10Data = true;
        const row = worksheet.addRow([
          item.PQR_MEX_Magnification || "--", "", "",
          item.PQR_MEX_Acceptance_Criteria || "--", "", "",
          item.PQR_MEX_Observation || "--", "", "", "", "", ""
        ]);
        worksheet.mergeCells(`A${row.number}:C${row.number}`);
        worksheet.mergeCells(`D${row.number}:F${row.number}`);
        worksheet.mergeCells(`G${row.number}:I${row.number}`);
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber > 9) return;
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    }
    if (!hasTable10Data) {
      const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "", "", ""]);
      worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`);
      worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`);
      worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`);
      emptyRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 9) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    // Result: A:B=label, C:I=value
    const macroResult = excelData.header[0]?.PQR_MEX_Result || excelData.details[0]?.PQR_MEX_Result || "";
    const macroResultRow = worksheet.addRow(["Result", "", macroResult, "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${macroResultRow.number}:B${macroResultRow.number}`);
    worksheet.mergeCells(`C${macroResultRow.number}:I${macroResultRow.number}`);
    macroResultRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 9) return;
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    worksheet.addRow([]);
    } // end macroCheck

    // MINIMUM LEAK PATH section
    const minLeakPathTitle = worksheet.addRow(["MINIMUM LEAK PATH", "", ""]);
    worksheet.mergeCells(`A${minLeakPathTitle.number}:C${minLeakPathTitle.number}`);
    minLeakPathTitle.getCell(1).font = { bold: true };
    minLeakPathTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    let allMinLeakData = [];
    if (excelData.header[0]?.Minimum_Leak_Path) allMinLeakData.push(...excelData.header[0].Minimum_Leak_Path);
    for (let i = 0; i < excelData.details.length; i++) allMinLeakData.push(...(excelData.details[i]?.Minimum_Leak_Path || []));

    // Cols A-E = Table1, F-G = gap, H-L = Table2 (single cells)
    const mlpSideBySideHeader = worksheet.addRow(["Tube No", "Loc A", "Loc B", "Loc C", "Loc D", "", "", "Tube No", "Loc A", "Loc B", "Loc C", "Loc D"]);
    mlpSideBySideHeader.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      if (colNumber !== 6 && colNumber !== 7) {
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    let table1Data = [], table2Data = [];
    for (let i = 0; i < allMinLeakData.length; i++) {
      table1Data.push(...(allMinLeakData[i]?.Table1 || []));
      table2Data.push(...(allMinLeakData[i]?.Table2 || []));
    }

    const mlpMaxRows = Math.max(table1Data.length, table2Data.length, 1);
    for (let rowIndex = 0; rowIndex < mlpMaxRows; rowIndex++) {
      const t1 = table1Data[rowIndex];
      const t2 = table2Data[rowIndex];
      const dataRow = worksheet.addRow([
        t1?.PQR_MLP_Tube_No || "--", t1?.PQR_MLP_LocA || "--", t1?.PQR_MLP_LocB || "--", t1?.PQR_MLP_LocC || "--", t1?.PQR_MLP_LocD || "--", "", "",
        t2?.PQR_MLP_Tube_No || "--", t2?.PQR_MLP_LocA || "--", t2?.PQR_MLP_LocB || "--", t2?.PQR_MLP_LocC || "--", t2?.PQR_MLP_LocD || "--"
      ]);
      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    worksheet.addRow([]);

    // Summary: A:D=Magnification, E:H=AccCriteria, I:L=Observation
    const minLeakSummaryHeader = worksheet.addRow(["Magnification", "", "", "", "Acceptance Criteria", "", "", "", "Observation", "", "", ""]);
    worksheet.mergeCells(`A${minLeakSummaryHeader.number}:D${minLeakSummaryHeader.number}`);
    worksheet.mergeCells(`E${minLeakSummaryHeader.number}:H${minLeakSummaryHeader.number}`);
    worksheet.mergeCells(`I${minLeakSummaryHeader.number}:L${minLeakSummaryHeader.number}`);
    minLeakSummaryHeader.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      cell.font = { bold: true };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    let hasTable5Data = false;
    for (let i = 0; i < allMinLeakData.length; i++) {
      (allMinLeakData[i]?.Table5 || []).forEach(item => {
        hasTable5Data = true;
        const row = worksheet.addRow([
          item.PQR_MLP_Magnification || "--", "", "", "",
          item.PQR_MLP_Acceptance_Criteria || "--", "", "", "",
          item.PQR_MLP_Observation || "--", "", "", ""
        ]);
        worksheet.mergeCells(`A${row.number}:D${row.number}`);
        worksheet.mergeCells(`E${row.number}:H${row.number}`);
        worksheet.mergeCells(`I${row.number}:L${row.number}`);
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber > 12) return;
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    }
    if (!hasTable5Data) {
      const emptyRow = worksheet.addRow(["--", "", "", "", "--", "", "", "", "--", "", "", ""]);
      worksheet.mergeCells(`A${emptyRow.number}:D${emptyRow.number}`);
      worksheet.mergeCells(`E${emptyRow.number}:H${emptyRow.number}`);
      worksheet.mergeCells(`I${emptyRow.number}:L${emptyRow.number}`);
      emptyRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber > 12) return;
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    // Result: A:B=label, C:I=value
    const minLeakResult = excelData.header[0]?.PQR_MLP_Result || excelData.details[0]?.PQR_MLP_Result || "";
    const minLeakResultRow = worksheet.addRow(["Result", "", minLeakResult, "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${minLeakResultRow.number}:B${minLeakResultRow.number}`);
    worksheet.mergeCells(`C${minLeakResultRow.number}:L${minLeakResultRow.number}`);
    minLeakResultRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Report Number: A:B=label, C:L=value
    const minLeakReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_MLP_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${minLeakReportRow.number}:B${minLeakReportRow.number}`);
    worksheet.mergeCells(`C${minLeakReportRow.number}:L${minLeakReportRow.number}`);
    minLeakReportRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber > 12) return;
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // PAGE 3 CONTENT - Additional Test sections from PDF page 3
    worksheet.addRow([]);
    worksheet.addRow([]);
    
    // TEAR TEST section
    if (excelData.header[0]?.tearCheck !== "No") {
    const tearTestTitle = worksheet.addRow(["TEAR TEST", "", ""]);
    worksheet.mergeCells(`A${tearTestTitle.number}:C${tearTestTitle.number}`); // Title spans A:B:C (3 columns)
    tearTestTitle.getCell(1).font = { bold: true };
    tearTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const tearTestHeader = worksheet.addRow(["TUBE NO", "", "", "", "Observation", "", "", "", "Results", "", "", ""]);
    
    // Merge header cells (4 columns each)
    worksheet.mergeCells(`A${tearTestHeader.number}:D${tearTestHeader.number}`); // TUBE NO (A:B:C:D)
    worksheet.mergeCells(`E${tearTestHeader.number}:H${tearTestHeader.number}`); // Observation (E:F:G:H)
    worksheet.mergeCells(`I${tearTestHeader.number}:L${tearTestHeader.number}`); // Results (I:J:K:L)
    
    tearTestHeader.eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      cell.font = { bold: true };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Add Tear Test data
    let tearTestData = [];
    if (excelData.header[0]?.Tear_Test) {
      tearTestData.push(...excelData.header[0].Tear_Test);
    }
    for (let i = 0; i < excelData.details.length; i++) {
      const detailTearTest = excelData.details[i]?.Tear_Test || [];
      tearTestData.push(...detailTearTest);
    }

    if (tearTestData.length > 0) {
      tearTestData.forEach(item => {
        const row = worksheet.addRow([
          item.PQR_Tear_TubeNo !== "" ? item.PQR_Tear_TubeNo : "--",
          "", // Column B (part of A:B:C:D merge)
          "", // Column C (part of A:B:C:D merge)
          "", // Column D (part of A:B:C:D merge)
          item.PQR_Tear_Observation !== "" ? item.PQR_Tear_Observation : "--",
          "", // Column F (part of E:F:G:H merge)
          "", // Column G (part of E:F:G:H merge)
          "", // Column H (part of E:F:G:H merge)
          item.PQR_Tear_Results !== "" ? item.PQR_Tear_Results : "--",
          "", // Column J (part of I:J:K:L merge)
          "", // Column K (part of I:J:K:L merge)
          "" // Column L (part of I:J:K:L merge)
        ]);
        
        // Merge data cells (4 columns each)
        worksheet.mergeCells(`A${row.number}:D${row.number}`); // TUBE NO (A:B:C:D)
        worksheet.mergeCells(`E${row.number}:H${row.number}`); // Observation (E:F:G:H)
        worksheet.mergeCells(`I${row.number}:L${row.number}`); // Results (I:J:K:L)
        
        row.eachCell((cell) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    } else {
      const emptyRow = worksheet.addRow(["--", "", "", "", "--", "", "", "", "--", "", "", ""]);
      
      // Merge empty data cells (4 columns each)
      worksheet.mergeCells(`A${emptyRow.number}:D${emptyRow.number}`); // TUBE NO (A:B:C:D)
      worksheet.mergeCells(`E${emptyRow.number}:H${emptyRow.number}`); // Observation (E:F:G:H)
      worksheet.mergeCells(`I${emptyRow.number}:L${emptyRow.number}`); // Results (I:J:K:L)
      
      emptyRow.eachCell((cell) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });
    }

    // Tear Test Notes
    const tearNotesRow = worksheet.addRow(["Notes", "", excelData.header[0]?.PQR_Tear_Notes || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${tearNotesRow.number}:B${tearNotesRow.number}`);
    worksheet.mergeCells(`C${tearNotesRow.number}:L${tearNotesRow.number}`);
    tearNotesRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Tear Test Report Number
    const tearReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_Tear_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${tearReportRow.number}:B${tearReportRow.number}`);
    worksheet.mergeCells(`C${tearReportRow.number}:L${tearReportRow.number}`);
    tearReportRow.eachCell((cell, colNumber) => {
      if (colNumber === 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
        cell.font = { bold: true };
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRow([]);
    } // end tearCheck

    // PULL OUT TEST section
      if (excelData.header[0]?.pullout_check !== "No") {
        const pullOutTestTitle = worksheet.addRow(["PULL OUT TEST", "", ""]);
        worksheet.mergeCells(`A${pullOutTestTitle.number}:C${pullOutTestTitle.number}`); // Title spans A:B:C (3 columns)
        pullOutTestTitle.getCell(1).font = { bold: true };
        pullOutTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

        const pullOutTestHeader = worksheet.addRow(["Tube No", "", "", "Location", "", "", "Load", "", "", "Fracture", "", ""]);
        
        // Merge header cells (3 columns each)
        worksheet.mergeCells(`A${pullOutTestHeader.number}:C${pullOutTestHeader.number}`); // Tube No (A:B:C)
        worksheet.mergeCells(`D${pullOutTestHeader.number}:F${pullOutTestHeader.number}`); // Location (D:E:F)
        worksheet.mergeCells(`G${pullOutTestHeader.number}:I${pullOutTestHeader.number}`); // Load (G:H:I)
        worksheet.mergeCells(`J${pullOutTestHeader.number}:L${pullOutTestHeader.number}`); // Fracture (J:K:L)
        
        pullOutTestHeader.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add Pull Out Test data
        let pullOutTestData = [];
        if (excelData.header[0]?.PullOut_Test) {
          pullOutTestData.push(...excelData.header[0].PullOut_Test);
        }
        for (let i = 0; i < excelData.details.length; i++) {
          const detailPullOut = excelData.details[i]?.PullOut_Test || [];
          pullOutTestData.push(...detailPullOut);
        }

        if (pullOutTestData.length > 0) {
          pullOutTestData.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_PullOut_TubeNo !== "" ? item.PQR_PullOut_TubeNo : "--",
              "", // Column B (part of A:B:C merge)
              "", // Column C (part of A:B:C merge)
              item.PQR_PullOut_Location !== "" ? item.PQR_PullOut_Location : "--",
              "", // Column E (part of D:E:F merge)
              "", // Column F (part of D:E:F merge)
              item.PQR_PullOut_Load !== "" ? item.PQR_PullOut_Load : "--",
              "", // Column H (part of G:H:I merge)
              "", // Column I (part of G:H:I merge)
              item.PQR_PullOut_Fracture !== "" ? item.PQR_PullOut_Fracture : "--",
              "", // Column K (part of J:K:L merge)
              "" // Column L (part of J:K:L merge)
            ]);
            
            // Merge data cells (3 columns each)
            worksheet.mergeCells(`A${row.number}:C${row.number}`); // Tube No (A:B:C)
            worksheet.mergeCells(`D${row.number}:F${row.number}`); // Location (D:E:F)
            worksheet.mergeCells(`G${row.number}:I${row.number}`); // Load (G:H:I)
            worksheet.mergeCells(`J${row.number}:L${row.number}`); // Fracture (J:K:L)
            
            row.eachCell((cell) => {
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
          });
        } else {
          const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "--", "", ""]);
          
          // Merge empty data cells (3 columns each)
          worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`); // Tube No (A:B:C)
          worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`); // Location (D:E:F)
          worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`); // Load (G:H:I)
          worksheet.mergeCells(`J${emptyRow.number}:L${emptyRow.number}`); // Fracture (J:K:L)
          
          emptyRow.eachCell((cell) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        }

        // Pull Out Test Notes
        const pullOutNotesRow = worksheet.addRow(["Notes", "", excelData.header[0]?.PQR_PullOut_Notes || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${pullOutNotesRow.number}:B${pullOutNotesRow.number}`);
        worksheet.mergeCells(`C${pullOutNotesRow.number}:L${pullOutNotesRow.number}`);
        pullOutNotesRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Pull Out Test Report Number
        const pullOutReportNumRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_PullOut_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${pullOutReportNumRow.number}:B${pullOutReportNumRow.number}`);
        worksheet.mergeCells(`C${pullOutReportNumRow.number}:L${pullOutReportNumRow.number}`);
        pullOutReportNumRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.addRow([]);

        // Calculation for Fr value section
        const frValueTitle = worksheet.addRow(["Calculation for Fr value", "", ""]);
        worksheet.mergeCells(`A${frValueTitle.number}:C${frValueTitle.number}`); // Title spans A:B:C (3 columns)
        frValueTitle.getCell(1).font = { bold: true };
        frValueTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

        const frValueFields = [
          { label: "Minimum Breaking Load (kN)", value: excelData.header[0]?.PQR_PullOut_MinBreakLoad || "" },
          { label: "Area of Tube Material (mm²)", value: excelData.header[0]?.PQR_PullOut_AreaTubeMaterial || "" },
          { label: "Minimum Specified Tensile Strength of Tube(MPa)", value: excelData.header[0]?.PQR_PullOut_MinTensilStrength || "" },
          { label: "Minimum Breaking Stress\n(= Minimum Breaking Load in kN / Area of Tube Material in mm²)", value: excelData.header[0]?.PQR_PullOut_MinBreakStress || "" },
          { label: "Fr Value\n(= Minimum Breaking Stress / Minimum Tensile Strength of Tube)", value: excelData.header[0]?.PQR_PullOut_FrValue || "" }
        ];

        frValueFields.forEach(field => {
          const row = worksheet.addRow([field.label, "", "", "", "", "", field.value, "", "", "", "", ""]);
          worksheet.mergeCells(`A${row.number}:F${row.number}`); // Label spans A:F (6 columns)
          worksheet.mergeCells(`G${row.number}:L${row.number}`); // Value spans G:L (6 columns)
          row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          row.getCell(1).font = { bold: true };
          row.getCell(1).alignment = { wrapText: true, vertical: 'top' };
          row.eachCell((cell) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            if (cell.col <= 6) { // Columns A-F (label area)
              cell.alignment = { horizontal: 'left', vertical: 'top', wrapText: true };
            } else { // Columns G-L (value area)
              cell.alignment = { horizontal: 'left', vertical: 'middle' };
            }
          });
          // Set row height for formula descriptions
          if (field.label.includes('\n')) {
            row.height = 40;
          }
        });

        worksheet.addRow([]);

        // Additional Pull Out Test table (Acceptance Criteria, Observation, Results)
        const pullOutAcceptanceHeader = worksheet.addRow(["Acceptance Criteria", "", "", "", "Observation", "", "", "", "Results", "", "", ""]);
        
        // Merge header cells (4 columns each)
        worksheet.mergeCells(`A${pullOutAcceptanceHeader.number}:D${pullOutAcceptanceHeader.number}`); // Acceptance Criteria (A:B:C:D)
        worksheet.mergeCells(`E${pullOutAcceptanceHeader.number}:H${pullOutAcceptanceHeader.number}`); // Observation (E:F:G:H)
        worksheet.mergeCells(`I${pullOutAcceptanceHeader.number}:L${pullOutAcceptanceHeader.number}`); // Results (I:J:K:L)
        
        pullOutAcceptanceHeader.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add Pull Out Test Table data
        let pullOutTestTableData = [];
        if (excelData.header[0]?.PullOut_Test_Table) {
          pullOutTestTableData.push(...excelData.header[0].PullOut_Test_Table);
        }
        for (let i = 0; i < excelData.details.length; i++) {
          const detailPullOutTable = excelData.details[i]?.PullOut_Test_Table || [];
          pullOutTestTableData.push(...detailPullOutTable);
        }

        if (pullOutTestTableData.length > 0) {
          pullOutTestTableData.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_PullOut_Acceptance_Criteria !== "" ? item.PQR_PullOut_Acceptance_Criteria : "--",
              "", // Column B (part of A:B:C:D merge)
              "", // Column C (part of A:B:C:D merge)
              "", // Column D (part of A:B:C:D merge)
              item.PQR_PullOut_Observation !== "" ? item.PQR_PullOut_Observation : "--",
              "", // Column F (part of E:F:G:H merge)
              "", // Column G (part of E:F:G:H merge)
              "", // Column H (part of E:F:G:H merge)
              item.PQR_PullOut_Results !== "" ? item.PQR_PullOut_Results : "--",
              "", // Column J (part of I:J:K:L merge)
              "", // Column K (part of I:J:K:L merge)
              "" // Column L (part of I:J:K:L merge)
            ]);
            
            // Merge data cells (4 columns each)
            worksheet.mergeCells(`A${row.number}:D${row.number}`); // Acceptance Criteria (A:B:C:D)
            worksheet.mergeCells(`E${row.number}:H${row.number}`); // Observation (E:F:G:H)
            worksheet.mergeCells(`I${row.number}:L${row.number}`); // Results (I:J:K:L)
            
            row.eachCell((cell) => {
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
          });
        } else {
          const emptyRow = worksheet.addRow(["--", "", "", "", "--", "", "", "", "--", "", "", ""]);
          
          // Merge empty data cells (4 columns each)
          worksheet.mergeCells(`A${emptyRow.number}:D${emptyRow.number}`); // Acceptance Criteria (A:B:C:D)
          worksheet.mergeCells(`E${emptyRow.number}:H${emptyRow.number}`); // Observation (E:F:G:H)
          worksheet.mergeCells(`I${emptyRow.number}:L${emptyRow.number}`); // Results (I:J:K:L)
          
          emptyRow.eachCell((cell) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        }

        // Pull Out Test Acceptance Criteria Notes
        const pullOutAccNotesRow = worksheet.addRow(["Notes", "", excelData.header[0]?.PQR_PullOut_AccCriteria_Notes || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${pullOutAccNotesRow.number}:B${pullOutAccNotesRow.number}`);
        worksheet.mergeCells(`C${pullOutAccNotesRow.number}:L${pullOutAccNotesRow.number}`);
        pullOutAccNotesRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Pull Out Test Report Number
        const pullOutReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_PullOut_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${pullOutReportRow.number}:B${pullOutReportRow.number}`);
        worksheet.mergeCells(`C${pullOutReportRow.number}:L${pullOutReportRow.number}`);
        pullOutReportRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.addRow([]);
      }

    // HARDNESS TEST section
      if (excelData.header[0]?.hardnessCheck !== "No") {
        const hardnessTestTitle = worksheet.addRow(["HARDNESS TEST", "", "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${hardnessTestTitle.number}:B${hardnessTestTitle.number}`);
        hardnessTestTitle.getCell(1).font = { bold: true };
        hardnessTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

        // A=Type(single), B=Tube No(single), C:D=BM-TS, E:F=HAZ-TS, G=Weld(single), H:I=HAZ-Tube, J:K=BM-Tube, L=Results(single)
        const hardnessTestHeader = worksheet.addRow(["Type (Scale)", "Tube No", "BM - Tube Sheet", "", "HAZ - Tube Sheet", "", "Weld", "HAZ - Tube", "", "BM - Tube", "", "Results"]);
        worksheet.mergeCells(`C${hardnessTestHeader.number}:D${hardnessTestHeader.number}`);
        worksheet.mergeCells(`E${hardnessTestHeader.number}:F${hardnessTestHeader.number}`);
        worksheet.mergeCells(`H${hardnessTestHeader.number}:I${hardnessTestHeader.number}`);
        worksheet.mergeCells(`J${hardnessTestHeader.number}:K${hardnessTestHeader.number}`);
        hardnessTestHeader.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber > 12) return;
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        let hardnessTestData = [];
        if (excelData.header[0]?.Hardness_Test) hardnessTestData.push(...excelData.header[0].Hardness_Test);
        for (let i = 0; i < excelData.details.length; i++) hardnessTestData.push(...(excelData.details[i]?.Hardness_Test || []));

        if (hardnessTestData.length > 0) {
          hardnessTestData.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_HT_TypeofTest || "--",
              item.PQR_HT_Tube_No || "--",
              item.PQR_HT_BM_Tubesheet || "--", "",
              item.PQR_HT_HAZ_Tubesheet || "--", "",
              item.PQR_HT_Weld || "--",
              item.PQR_HT_HAZ_Tube || "--", "",
              item.PQR_HT_BM_Tube || "--", "",
              item.PQR_HT_Results || "--"
            ]);
            worksheet.mergeCells(`C${row.number}:D${row.number}`);
            worksheet.mergeCells(`E${row.number}:F${row.number}`);
            worksheet.mergeCells(`H${row.number}:I${row.number}`);
            worksheet.mergeCells(`J${row.number}:K${row.number}`);
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
              if (colNumber > 12) return;
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
          });
        } else {
          const emptyRow = worksheet.addRow(["--", "--", "--", "", "--", "", "--", "--", "", "--", "", "--"]);
          worksheet.mergeCells(`C${emptyRow.number}:D${emptyRow.number}`);
          worksheet.mergeCells(`E${emptyRow.number}:F${emptyRow.number}`);
          worksheet.mergeCells(`H${emptyRow.number}:I${emptyRow.number}`);
          worksheet.mergeCells(`J${emptyRow.number}:K${emptyRow.number}`);
          emptyRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 12) return;
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        }

        // Notes: A=label(single), B:L=value
        const hardnessNotesRow = worksheet.addRow(["Notes", excelData.header[0]?.PQR_HT_Notes || "", "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`B${hardnessNotesRow.number}:L${hardnessNotesRow.number}`);
        hardnessNotesRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber > 12) return;
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Report Number: A=label(single), B:L=value
        const hardnessReportRow = worksheet.addRow(["Report Number", excelData.header[0]?.PQR_HT_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`B${hardnessReportRow.number}:L${hardnessReportRow.number}`);
        hardnessReportRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber > 12) return;
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        worksheet.addRow([]);
      }

    // RADIOGRAPHY TEST section
      if (excelData.header[0]?.radioCheck !== "No") {
        const radiographyTestTitle = worksheet.addRow(["RADIOGRAPHY TEST", "", ""]);
        worksheet.mergeCells(`A${radiographyTestTitle.number}:C${radiographyTestTitle.number}`); // Title spans A:B:C (3 columns)
        radiographyTestTitle.getCell(1).font = { bold: true };
        radiographyTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

        const radiographyTestHeader = worksheet.addRow(["Tube No", "", "", "Acceptance Criteria", "", "", "Observation", "", "", "Results", "", ""]);
        
        // Merge header cells (3 columns each)
        worksheet.mergeCells(`A${radiographyTestHeader.number}:C${radiographyTestHeader.number}`); // Tube No (A:B:C)
        worksheet.mergeCells(`D${radiographyTestHeader.number}:F${radiographyTestHeader.number}`); // Acceptance Criteria (D:E:F)
        worksheet.mergeCells(`G${radiographyTestHeader.number}:I${radiographyTestHeader.number}`); // Observation (G:H:I)
        worksheet.mergeCells(`J${radiographyTestHeader.number}:L${radiographyTestHeader.number}`); // Results (J:K:L)
        
        radiographyTestHeader.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add Radiography Test data
        let radiographyTestData = [];
        if (excelData.header[0]?.Radiography_Test) {
          radiographyTestData.push(...excelData.header[0].Radiography_Test);
        }
        for (let i = 0; i < excelData.details.length; i++) {
          const detailRadiography = excelData.details[i]?.Radiography_Test || [];
          radiographyTestData.push(...detailRadiography);
        }

        if (radiographyTestData.length > 0) {
          radiographyTestData.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_Radio_TubeNo !== "" ? item.PQR_Radio_TubeNo : "--",
              "", // Column B (part of A:B:C merge)
              "", // Column C (part of A:B:C merge)
              item.PQR_Radio_Acceptance_Criteria !== "" ? item.PQR_Radio_Acceptance_Criteria : "--",
              "", // Column E (part of D:E:F merge)
              "", // Column F (part of D:E:F merge)
              item.PQR_Radio_Observation !== "" ? item.PQR_Radio_Observation : "--",
              "", // Column H (part of G:H:I merge)
              "", // Column I (part of G:H:I merge)
              item.PQR_Radio_Results !== "" ? item.PQR_Radio_Results : "--",
              "", // Column K (part of J:K:L merge)
              "" // Column L (part of J:K:L merge)
            ]);
            
            // Merge data cells (3 columns each)
            worksheet.mergeCells(`A${row.number}:C${row.number}`); // Tube No (A:B:C)
            worksheet.mergeCells(`D${row.number}:F${row.number}`); // Acceptance Criteria (D:E:F)
            worksheet.mergeCells(`G${row.number}:I${row.number}`); // Observation (G:H:I)
            worksheet.mergeCells(`J${row.number}:L${row.number}`); // Results (J:K:L)
            
            row.eachCell((cell) => {
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
          });
        } else {
          const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "--", "", ""]);
          
          // Merge empty data cells (3 columns each)
          worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`); // Tube No (A:B:C)
          worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`); // Acceptance Criteria (D:E:F)
          worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`); // Observation (G:H:I)
          worksheet.mergeCells(`J${emptyRow.number}:L${emptyRow.number}`); // Results (J:K:L)
          
          emptyRow.eachCell((cell) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        }

        // Radiography Test Notes
        const radiographyNotesRow = worksheet.addRow(["Notes", "", excelData.header[0]?.PQR_Radio_Notes || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${radiographyNotesRow.number}:B${radiographyNotesRow.number}`);
        worksheet.mergeCells(`C${radiographyNotesRow.number}:L${radiographyNotesRow.number}`);
        radiographyNotesRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Radiography Test Report Number
        const radiographyReportRow = worksheet.addRow(["Report Number", "", excelData.header[0]?.PQR_Radio_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${radiographyReportRow.number}:B${radiographyReportRow.number}`);
        worksheet.mergeCells(`C${radiographyReportRow.number}:L${radiographyReportRow.number}`);
        radiographyReportRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.addRow([]);
      }

    // OTHER TEST section
      if (excelData.header[0]?.otherCheck !== "No") {
        const otherTestTitle = worksheet.addRow(["OTHER TEST", "", "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${otherTestTitle.number}:C${otherTestTitle.number}`);
        otherTestTitle.getCell(1).font = { bold: true };
        otherTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

        const otherTestHeader = worksheet.addRow(["Type of Test", "", "", "Acceptance Criteria", "", "", "Results", "", "", "Remarks", "", ""]);
        
        // Merge header cells (3 columns each)
        worksheet.mergeCells(`A${otherTestHeader.number}:C${otherTestHeader.number}`); // Type of Test (A:B:C)
        worksheet.mergeCells(`D${otherTestHeader.number}:F${otherTestHeader.number}`); // Acceptance Criteria (D:E:F)
        worksheet.mergeCells(`G${otherTestHeader.number}:I${otherTestHeader.number}`); // Results (G:H:I)
        worksheet.mergeCells(`J${otherTestHeader.number}:L${otherTestHeader.number}`); // Remarks (J:K:L)
        
        otherTestHeader.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
          cell.font = { bold: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add Other Test data
        let otherTestData = [];
        if (excelData.header[0]?.Other_Test) {
          otherTestData.push(...excelData.header[0].Other_Test);
        }
        for (let i = 0; i < excelData.details.length; i++) {
          const detailOther = excelData.details[i]?.Other_Test || [];
          otherTestData.push(...detailOther);
        }

        if (otherTestData.length > 0) {
          otherTestData.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_OT_TypeofTest !== "" ? item.PQR_OT_TypeofTest : "--",
              "", // Column B (part of A:B:C merge)
              "", // Column C (part of A:B:C merge)
              item.PQR_OT_Acceptance_Criteria !== "" ? item.PQR_OT_Acceptance_Criteria : "--",
              "", // Column E (part of D:E:F merge)
              "", // Column F (part of D:E:F merge)
              item.PQR_OT_Results !== "" ? item.PQR_OT_Results : "--",
              "", // Column H (part of G:H:I merge)
              "", // Column I (part of G:H:I merge)
              item.PQR_OT_Remarks !== "" ? item.PQR_OT_Remarks : "--",
              "", // Column K (part of J:K:L merge)
              "" // Column L (part of J:K:L merge)
            ]);
            
            // Merge data cells (3 columns each)
            worksheet.mergeCells(`A${row.number}:C${row.number}`); // Type of Test (A:B:C)
            worksheet.mergeCells(`D${row.number}:F${row.number}`); // Acceptance Criteria (D:E:F)
            worksheet.mergeCells(`G${row.number}:I${row.number}`); // Results (G:H:I)
            worksheet.mergeCells(`J${row.number}:L${row.number}`); // Remarks (J:K:L)
            
            row.eachCell((cell) => {
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
          });
        } else {
          const emptyRow = worksheet.addRow(["--", "", "", "--", "", "", "--", "", "", "--", "", ""]);
          
          // Merge empty data cells (3 columns each)
          worksheet.mergeCells(`A${emptyRow.number}:C${emptyRow.number}`); // Type of Test (A:B:C)
          worksheet.mergeCells(`D${emptyRow.number}:F${emptyRow.number}`); // Acceptance Criteria (D:E:F)
          worksheet.mergeCells(`G${emptyRow.number}:I${emptyRow.number}`); // Results (G:H:I)
          worksheet.mergeCells(`J${emptyRow.number}:L${emptyRow.number}`); // Remarks (J:K:L)
          
          emptyRow.eachCell((cell) => {
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
        }

        // Other Test Notes
        const otherNotesRow = worksheet.addRow(["Notes", "", excelData.header[0]?.PQR_OT_Notes || "", "", "", "", "", "", "", "", "", ""]);
        worksheet.mergeCells(`A${otherNotesRow.number}:B${otherNotesRow.number}`); // Notes header spans A:B (2 columns)
        worksheet.mergeCells(`C${otherNotesRow.number}:L${otherNotesRow.number}`); // Notes value spans C:L (10 columns)
        otherNotesRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) { // Only column A gets the styling since A:B is merged
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.addRow([]);
      }

    // Certification statement
    const certificationRow = worksheet.addRow(["We certify that the statements in this record are correct and that the test welds were prepared, welded, and tested in accordance with the requirements of Section IX of the ASME Boiler and Pressure Vessel Code."]);
    worksheet.mergeCells(`A${certificationRow.number}:L${certificationRow.number}`);
    certificationRow.getCell(1).font = { italic: true };
    certificationRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
    certificationRow.height = 40;

    // 5 empty rows before signature
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Labels row
    const sigLabelRow = worksheet.addRow(["Welding Engineer", "", "", "", "", "", "Witness By", "", "", "", "", ""]);
    worksheet.mergeCells(`A${sigLabelRow.number}:F${sigLabelRow.number}`);
    worksheet.mergeCells(`G${sigLabelRow.number}:L${sigLabelRow.number}`);
    sigLabelRow.getCell(1).font = { bold: true };
    sigLabelRow.getCell(7).font = { bold: true };

    // Name + Signature on same row — all 4 merged per-row, all bordered
    const sigNameRow = worksheet.addRow(["Name", "", "", "Signature", "", "", "Name", "", "", "Signature", "", ""]);
    worksheet.mergeCells(`A${sigNameRow.number}:C${sigNameRow.number}`);
    worksheet.mergeCells(`D${sigNameRow.number}:F${sigNameRow.number}`);
    worksheet.mergeCells(`G${sigNameRow.number}:I${sigNameRow.number}`);
    worksheet.mergeCells(`J${sigNameRow.number}:L${sigNameRow.number}`);
    for (let c = 1; c <= 12; c++) {
      sigNameRow.getCell(c).alignment = { horizontal: 'left', vertical: 'middle' };
      sigNameRow.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // 3 rows below: A:C and G:I per-row; D:F and J:L vertically merged across all 3 (3×3 signature area)
    const sigR1 = worksheet.addRow(["", "", "", "", "", "", "", "", "", "", "", ""]);
    const sigR2 = worksheet.addRow(["Date", "", "", "", "", "", "Date", "", "", "", "", ""]);
    const sigR3 = worksheet.addRow(["", "", "", "", "", "", "", "", "", "", "", ""]);

    // Vertical merge D:F and J:L across 3 rows — no prior access to these cells
    worksheet.mergeCells(`D${sigR1.number}:F${sigR3.number}`);
    worksheet.mergeCells(`J${sigR1.number}:L${sigR3.number}`);
    worksheet.getCell(`D${sigR1.number}`).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    worksheet.getCell(`J${sigR1.number}`).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

    [sigR1, sigR2, sigR3].forEach(row => {
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`G${row.number}:I${row.number}`);
      [1, 2, 3, 7, 8, 9].forEach(c => {
        row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    });
    sigR2.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
    sigR2.getCell(7).alignment = { horizontal: 'left', vertical: 'middle' };

    // Generate and download file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `PQR_Tubesheet_Report_${headerData.PQR_RecordNo || 'Export'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    link.click();
    
    window.URL.revokeObjectURL(url);
    
    setLoading(false);
    props.onHide();
    } catch (error) {
      console.error('Error generating Excel file:', error);
      alert('Failed to generate Excel file. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (excelData.header.length > 0) {
      setTimeout(() => {
        generateExcel();
      }, 1000);
    }
  }, [excelData]);

  return (
    <Modal
      {...props}
      size="sm"
      centered
      backdrop="static"
    >
      <Modal.Body style={{ maxHeight: "calc(10vh - 10px)" }}>
        <p>
          {loading && (
            <BarLoader
              color="blue"
              height={8}
              width={196}
              className="shift"
            />
          )}
        </p>
        <p style={{ textAlign: 'center', marginTop: '8px', marginBottom: '8px', fontSize: '14px' }}>Generating Excel file...</p>
      </Modal.Body>
    </Modal>
  );
};

export default Excel_DownloadPQR_Tubesheet;